import api from './axios'

// 회원가입 시 본인인증용 이메일 전송 코드
export const sendEmailAuth = async(email) => {
  return await api.post('users/send-email', { email });
};

// 본인인증 코드 확인 
export const verifyCode = async(data) => {
  // data = { email, tempCode }
  return await api.post('users/auth-tempcode', data);
};

// 회원가입(정보입력)
export const registerUser = async(data) => {
  // data = { name, email, password, phoneNumber, tos }
  await api.post('users/register', data);
};

// 아이 등록
export const registerChild = async(data) => {
  // data = { name, birthday, gender, language_disorder_type }
  await api.post('users/register-child', data);
};

// 아이 음성 등록
export const registerVoice = async(formData) => {
  const res = await api.post("/word-records/register-voice", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return res.data
}

// 로그인
export const loginUser = async(data) => {
  // data = { email, password }
  await api.post('users/login', data);
};

// 로그아웃
export const logout = async() => {
  const res = await api.post('users/logout')
  return res.data;
}

// 비밀번호 찾기에서 본인인증용 이메일 전송 코드
export const sendResetPasswordEmail = async(email) => {
  return await api.post('users/send-email/password-update', { email });
};

// 비밀번호 재설정
export const ResetPassword = async(data) => {
  // data = { email, password }
  return await api.put('users/update-password', data);
};

// 로그인 여부 받기
export const getLoginStatus = async() => {
  const res = await api.get("users/login/check")
  return res.data
}